import { useLanguageContext } from "../../../../context/LanguageContext";
import EVAApiHelper from "../../../../helpers/EVAApiHelper";
import InputWrapper from "../../../input/wrapper/InputWrapper";
import HiddenLoader from "../../../loader/HiddenLoader/HiddenLoader";
import Select from "../../../select/main/Select";
import FlowPlayerControls from "../../controls/FlowPlayerControls";

function EmployeeStepView({
  controller,
  employeeOptions,
  setSearch,
  onEmployeeIdChange,
}) {
  const { translate } = useLanguageContext();

  return (
    <FlowPlayerControls controller={controller}>
      <HiddenLoader groups={"employee_step_fetch"}>
        <InputWrapper
          label={translate(
            "eva.frontoffice.pages.visitor_type.steps.employee.fields.employee",
          )}
          error={EVAApiHelper.getResponseError(
            "employee_id",
            controller.errors,
          )}
          required={true}
        >
          <Select
            searchable={true}
            onSearchChanged={setSearch}
            value={controller.visitorData.employee_id}
            options={employeeOptions}
            onChange={onEmployeeIdChange}
          />
        </InputWrapper>
      </HiddenLoader>
    </FlowPlayerControls>
  );
}

export default EmployeeStepView;
